.root {
  transition-property: height;
  transition-duration: 0.25s;
  overflow: hidden;
  position: relative;
  box-sizing: content-box;
}